export const COUPON_REDIRECT_MESSAGE = 'Sign in to redeem your coupon.';

export const INVALID_OFFER_FLASH_TEXT = 'Invalid offer link';
